<template>
<div id="bonus">
    <div class="info title clearfix" style="background: url('/static/uploads/2018/09/20/22/50/header-bonus.jpg') 0 0 no-repeat;background-position: center center;">
        <div class="wrapper clearfix">
            <div class="col-xs-120">
                <h1>Магазин подарков</h1>
                <h3><br/>Обменивайте бонусные рубли не только на ремонт, но и на подарки от наших партнеров!</h3>
            </div>
        </div>
    </div>
    <div class="col-xs-120 text_raw_main_div">
        <p>Для получения подарков нужно <router-link to="/cabinet/login/">авторизоваться</router-link> или <router-link to="/cabinet/registration/">зарегистрироваться</router-link>. За регистрацию Вам начисляется 500 {{city.valute}} на счет, <br/>а все дополнительные приятные подарки и бонусы – в Вашем личном кабинете.</p>
    </div>
    <div class="category clearfix category-links" style="padding-bottom: 0px;">
        <div class="wrapper clearfix">
            <div class="col-md-29 col-sm-60 no-padding choose-marka clearfix" id="marka-form-choose" style="margin-left: 0px;">
                <div class="label_bonus">Категория</div>
                <ul class="menu left">
                    <li v-for="(category, key) in categories" :key="key"><a href="#" class="data_categories" :data-bid="key">{{category}}</a></li>
                    <li><a href="#" class="data_categories" data-bid="avtoservices">Автосервисы принимающие бонусы</a></li>
                </ul>
            </div>
            <div class="menu_right_categories col-md-90 col-sm-120 col-xs-120">
                <div class="menu_right_element_one" v-for="bonus in bonus_list" :key="'bonus' + bonus.id" :data-category="bonus.category">
                    <p class="menu_right_header_text_bonus">{{bonus.title}}</p>
                    <img :src="bonus.photo" class="kluch_image">
                    <p class="p_text_bonus">{{bonus.desc}}</p>
                    <div class="container_button_in_text">
                        <div class="bonus_prise_container">
                            <p class="bonus_prise">{{bonus.price}} баллов</p>
                        </div>
                        <div class="bonus_button_container">
                            <input type="button" @click="sendBonus(bonus.id, bonus.price)"  v-if="auth.id && auth.bonus > bonus.price" value="ПОЛУЧИТЬ" class="bonus_button">
                        </div>
                    </div>
                </div>
                <div class="menu_right_element_one" v-for="avtoservice in avtoservices" :key="'service' + avtoservice.id" data-category="avtoservices">
                    <p class="menu_right_header_text_bonus">{{avtoservice.name}}</p>
                    <img :src="avtoservice.photo" class="kluch_image">
                    <p class="p_text_bonus">Этот сервис принимает к оплате бонусные деньги в размере {{avtoservice.bonus}}%</p>
                    <div class="container_button_in_text">
                        <div class="bonus_button_container">
                            <router-link :to="'/avtoservis/'+avtoservice.id+'/'" class="btn btn-success" type="button">Перейти</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- HTML-код модального окна -->
    <div id="successForm" :class="[bonusGive ? 'modal show' : 'modal fade']" v-click-outside="hideBonus">
        <div class="modal-dialog">
            <div class="modal-content">
                <!-- Заголовок модального окна -->
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" @click="hideBonus">×</button>
                </div>
                <div class="modal-body">
                    <div class="alert alert-success text-center">Ваша заявка отправлена!<br>В самое ближайшее время Вам поступит сообщение!</div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from '@/router/http'
import $ from 'jquery'
export default {
  name: 'Bonus',
  props: ['city', 'user', 'auth'],
  data () {
    return {
      categories: [],
      bonus_list: [],
      avtoservices: [],
      bonusGive: 0
    }
  },
  created () {
    axios.get('https://crm.v-avtoservice.com/list/site-bonus-categories?lang=' + this.city.lang).then(response => {
      this.categories = response.data
      setTimeout(function () {
        $('.data_categories').on('click', function (e) {
          e.preventDefault()
          console.log('asd')
          $('.menu_right_element_one').hide()
          $('.menu_right_element_one[data-category="' + $(this).data('bid') + '"]').show()
        })
      }, 300)
    })
    axios.get('https://crm.v-avtoservice.com/list/site-bonus-list?lang=' + this.city.lang + '&city=' + this.city.id).then(response => {
      this.bonus_list = response.data
    })
    axios.get('https://crm.v-avtoservice.com/list/site-bonus-services?city=' + this.city.id).then(response => {
      this.avtoservices = response.data
    })
  },
  methods: {
    sendBonus (id, price) {
      this.bonusGive = 1
      this.auth.bonus -= price
      axios.get('https://crm.v-avtoservice.com/list/site-get-bonus?uid=' + this.user.uid + '&id=' + id).then(response => {
        axios.get('https://crm.v-avtoservice.com/list/site-get-auth?uid=' + this.user.uid).then(response => {
          this.auth = response.data
        })
      })
    },
    hideBonus () {
      this.bonusGive = 0
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Bonus.vue